module.exports = __webpack_public_path__ + "static/media/elonmusk.281fcfd6.jpg";